import React from "react";
import { ToggleGroup, ToggleGroupItem } from "@components/ui/toggle-group";

type RangeOption = "custom" | "60d" | "30d" | "7d" | "24h";

interface SegmentedControlProps {
  activeRange: RangeOption;
  onRangeSelect: (range: RangeOption) => void;
  options?: Array<{ value: RangeOption; label: string }>;
  onCustomClick?: () => void;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  activeRange,
  onRangeSelect,
  options = [
    { value: "custom", label: "Custom" },
    { value: "60d", label: "60 days" },
    { value: "30d", label: "30 days" },
    { value: "7d", label: "7 days" },
    { value: "24h", label: "Today" },
  ],
  onCustomClick,
}) => {
  const handleValueChange = (value: string) => {
    if (!value) {
      return;
    }

    const selectedValue = value as RangeOption;

    if (selectedValue === "custom" && onCustomClick) {
      onCustomClick();
    }

    onRangeSelect(selectedValue);
  };

  return (
    <ToggleGroup
      type="single"
      value={activeRange}
      onValueChange={handleValueChange}
      className="flex flex-wrap items-center gap-1 rounded-lg border border-input bg-muted/40 p-1"
    >
      {options.map((option, index) => {
        return (
          <ToggleGroupItem
            key={option.value}
            value={option.value}
            className="rounded-md border border-transparent px-3 py-1.5 text-xs font-medium text-muted-foreground transition-colors hover:text-foreground data-[state=on]:border-primary data-[state=on]:bg-primary data-[state=on]:text-primary-foreground sm:text-sm"
            aria-label={`Select ${option.label.toLowerCase()} range`}
          >
            {option.label}
          </ToggleGroupItem>
        );
      })}
    </ToggleGroup>
  );
};

export default SegmentedControl;
